import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { Spinner } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const { refreshUser } = useAuth();
  const [state, setState] = useState("checking");
  useEffect(() => {
    let n = 0;
    let stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${sp.get("session_id")}`);
        if (data.payment_status === "paid") { setState("paid"); refreshUser(); return; }
        if (data.status === "expired") { setState("failed"); return; }
      } catch { setState("failed"); return; }
      if (++n < 10 && !stop) setTimeout(poll, 2000); else setState("pending");
    };
    poll();
    return () => { stop = true; };
  }, [sp, refreshUser]);
  return (
    <div className="mx-auto max-w-lg py-10" data-testid="payment-result">
      {state === "checking" && <Spinner label="Confirming your payment…" />}
      {state === "paid" && <div className="card p-8 text-center"><CheckCircle2 className="mx-auto h-12 w-12 text-teal-600" /><h1 className="mt-4 text-2xl font-bold">You're upgraded!</h1><p className="mt-2 text-slate-600">Premium features are now active on trips you own.</p><Link to="/dashboard" className="mt-6 inline-block rounded-full bg-orange-500 px-6 py-3 font-semibold text-white" data-testid="payment-back-dashboard">Back to my trips</Link></div>}
      {state === "pending" && <div className="card p-8 text-center"><h1 className="text-2xl font-bold">Still processing</h1><p className="mt-2 text-slate-600">Your payment is taking a little longer. Refresh the Billing page in a minute.</p><Link to="/billing" className="mt-6 inline-block font-semibold text-orange-600">Go to billing</Link></div>}
      {state === "failed" && <div className="card p-8 text-center"><XCircle className="mx-auto h-12 w-12 text-rose-500" /><h1 className="mt-4 text-2xl font-bold">Payment not completed</h1><p className="mt-2 text-slate-600">No charge was made. You can try again anytime.</p><Link to="/billing" className="mt-6 inline-block font-semibold text-orange-600">Back to billing</Link></div>}
    </div>
  );
}
